var _path, _path2, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleRing = function SvgCircleRing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#circleRing_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.222,
    d: "M40.945 49.833a4.445 4.445 0 0 1-8.89 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#circleRing_svg__b)",
    strokeWidth: 3.333,
    d: "m24.81 34.944 1.662.134.005-.067v-5.844c0-5.444 4.47-9.89 10.023-9.89 5.554 0 10.023 4.446 10.023 9.89v5.844l.005.067 1.661-.134c-1.66.134-1.66.135-1.66.136v.013l.002.021a4 4 0 0 0 .029.227c.02.137.053.322.105.546.103.447.283 1.052.596 1.74.63 1.385 1.794 3.093 3.908 4.487 1.058.697 1.442 1.65 1.442 2.22 0 .272-.08.376-.1.397 0 0-.079.102-.425.102H20.914c-.34 0-.422-.098-.426-.102-.019-.021-.1-.125-.1-.398 0-.57.385-1.522 1.443-2.22 2.114-1.392 3.278-3.1 3.907-4.486a9.3 9.3 0 0 0 .597-1.74 7 7 0 0 0 .133-.773l.002-.02.001-.009v-.006z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    x: 3.5,
    y: 3.5,
    stroke: "url(#circleRing_svg__c)",
    strokeWidth: 6,
    rx: 33
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "circleRing_svg__a",
    x1: 36.5,
    x2: 36.5,
    y1: 49.833,
    y2: 54.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circleRing_svg__b",
    x1: 36.5,
    x2: 36.5,
    y1: 17.611,
    y2: 46.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circleRing_svg__c",
    x1: 36.5,
    x2: 36.5,
    y1: 0.5,
    y2: 72.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B9F7"
  })))));
};
export default SvgCircleRing;